module.exports = __webpack_public_path__ + "static/img/k3.100ee502.png";